import script from "./ml-input.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-input.vue?vue&type=script&setup=true&lang=js"

import "./ml-input.vue?vue&type=style&index=0&id=dbddf134&lang=scss"

const __exports__ = script;

export default __exports__